import { create } from 'zustand';
import { persist } from 'zustand/middleware';

import type { AuthTokens, User } from '@/types/api';

interface AuthState {
  user: User | null;
  tokens: AuthTokens | null;
  hydrated: boolean;
  setSession: (user: User, tokens: AuthTokens) => void;
  setUser: (user: User) => void;
  clear: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      user: null,
      tokens: null,
      hydrated: false,
      setSession: (user, tokens) => set({ user, tokens }),
      setUser: (user) => set({ user }),
      clear: () => set({ user: null, tokens: null }),
      isAuthenticated: () => Boolean(get().tokens?.accessToken && get().user),
    }),
    {
      name: 'vmdl.auth',
      partialize: (state) => ({ user: state.user, tokens: state.tokens }),
      onRehydrateStorage: () => (state) => {
        if (state) state.hydrated = true;
      },
    },
  ),
);
